module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.show) ? _c('svgEditor', {
    attrs: {
      "say2father": _vm.say2father
    }
  }) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("打些想對爸爸說的話")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.say2father),
      expression: "say2father"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.say2father)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.say2father = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-lg",
    attrs: {
      "id": "downloadBtn"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("下載")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-lg",
    attrs: {
      "id": "resetBtn"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重新填寫")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-410339e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 10
// module chunks = 0